import { loginFailure, loginStart, loginSuccess } from "./userSlice";
import {
  dashboardDataFailure,
  dashboardDataRequest,
  dashboardDataSuccess,
} from "./dashboardSlice";
import {
  tasksDataFailure,
  tasksDataRequest,
  tasksDataSuccess,
} from "./tasksSlice";
import {
  resetPassRequest,
  resetPassSuccess,
  resetPassFailure,
} from "./resetPassSlice";
import { axiosPrivate, axiosPublic } from "../Requests";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

export const login = async (dispatch, user) => {
  dispatch(loginStart());
  try {
    const res = await axiosPublic.post("/auth/login", user);
    const data = res?.data?.data?.tokens;
    if (res?.data?.message === "Login Success") {
      dispatch(loginSuccess(res.data));
      sessionStorage.setItem("accessJWT", data?.accessToken);
      localStorage.setItem("refreshJWT", data.refreshToken);
      localStorage.setItem(
        "userInfo",
        JSON.stringify({ users: res?.data?.data?.user })
      );
      toast.success("Login Successfully");
    }
  } catch (err) {
    console.log(err.response.data);
    dispatch(loginFailure(err.response.data));
    toast.error(err.message);
  }
};

export const resetPassData = async (dispatch, email) => {
  dispatch(resetPassRequest());
  try {
    const res = await axiosPublic.post("/auth/reset_password", email);
    dispatch(resetPassSuccess(res.data));
    toast.success("Email Send Successfully");
  } catch (err) {
    console.log(err);
    dispatch(resetPassFailure());
    toast.error(err.message);
  }
};
export const dashboardData = async (dispatch, TOKEN) => {
  dispatch(dashboardDataRequest());
  console.log("token is:", TOKEN);
  try {
    const res = await axiosPrivate(TOKEN).get("/user/dashboard");
    dispatch(dashboardDataSuccess(res.data));
    toast.success("Data is Loaded Successfully");
  } catch (err) {
    console.log(err);
    dispatch(dashboardDataFailure());
    toast.error(err.message);
  }
};

export const tasksData = async (dispatch, type, TOKEN) => {
  console.log(type);
  dispatch(tasksDataRequest());
  try {
    const res = await axiosPrivate(TOKEN).get("/user/"+type);
      console.log(res.data);
      dispatch(tasksDataSuccess(res.data.data.data));
      toast.success("Data is Loaded Successfully");
    
  } catch (err) {
    console.log(err);
    dispatch(tasksDataFailure());
    toast.error(err.message);
  }
};
